import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { NotificationMessageComponent } from '../../Components/dialogs/common/notification-message/notification-message.component';
import { CONSTANTS } from '../../Constants/Constants';

@Injectable({ providedIn: 'root' })
export class NotificationMessageService {
	constructor(private dialog: MatDialog) { }

	showNotificationMessageDialog(type: string, title: string, message: string, width: string = CONSTANTS.DEFAULT_DIALOG_WIDTH): void {
		this.dialog.open(NotificationMessageComponent, {
			width: width,
			data: {
				type,
				title,
				message
			},
			disableClose: true
		});
	}

	showError(message: string, title: string = CONSTANTS.ERROR_TITLE, width: string = CONSTANTS.DEFAULT_DIALOG_WIDTH): void {
		this.showNotificationMessageDialog(CONSTANTS.TYPE_ERROR, title, message, width);
	}

	showWarning(message: string, title: string = CONSTANTS.WARNING_TITLE, width: string = CONSTANTS.DEFAULT_DIALOG_WIDTH): void {
		this.showNotificationMessageDialog(CONSTANTS.TYPE_WARNING, title, message, width);
	}

	showInfo(message: string, title: string = CONSTANTS.INFO_TITLE, width: string = CONSTANTS.DEFAULT_DIALOG_WIDTH): void {
		this.showNotificationMessageDialog(CONSTANTS.TYPE_INFO, title, message, width);
	}

	showSuccess(message: string, title: string = CONSTANTS.SUCCESS_TITLE, width: string = CONSTANTS.DEFAULT_DIALOG_WIDTH): void {
		this.showNotificationMessageDialog(CONSTANTS.TYPE_SUCCESS, title, message, width);
	}
}
